export default __webpack_public_path__ + "static/media/location_preview_stadium.53b99e56.svg";